import {signalSvg as Icon__small__signalSvg} from '../Icon__small/Icon__small--signal.js';
import {signalSvg as Icon__xsmall__signalSvg} from '../Icon__xsmall/Icon__xsmall--signal.js';

export var signal = {
  name: 'signal',
  category: 'icon',
  colorable: true,
  svg: Icon__small__signalSvg,
  alt: {
    Icon__small: Icon__small__signalSvg,
    Icon__xsmall: Icon__xsmall__signalSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
